// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__23abd","perdeu":"LoginForm_perdeu__1PKBW","cadastro":"LoginForm_cadastro__37b4Z","subtitle":"LoginForm_subtitle__2UqWV"};